import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { MAT_DATE_LOCALE, MatInputModule, MatNativeDateModule, MatTabsModule } from '@angular/material';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from './core/core.module';
import { DatePipe } from '@angular/common';
import { EditmodalComponent } from '././components/approver/editmodal/editmodal.component';
import { FormlyModule } from '@ngx-formly/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { HttpInterceptorService } from './components/sessions/login/http-interceptor.service';
import { LoaderInterceptor } from '@core/interceptors/loadingInterceptor';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { NoCacheHeadersInterceptor } from '@core/interceptors/noCacheHeadersInterceptor ';
import { QuillModule } from 'ngx-quill';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { SampleComponent } from './components/sample/sample.component';
import { SharedModule } from './shared/shared.module';
import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { StartupService } from '@core';
import { StorageServiceModule } from 'angular-webstorage-service';
import { ThemeModule } from './theme/theme.module';
import { ToastrModule } from 'ngx-toastr';
import { SsoLoginComponent } from './components/sessions/sso-login/sso-login.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { LoaderComponent } from './theme/loader/loader.component';
//import { LoaderComponent } from 'app/theme/loader.component'
// import { EditorModule } from '@tinymce/tinymce-angular';
import { Error404PageComponent } from './components/error404-page/error404-page.component';
import { GlobalErrorHandler } from '@core/interceptors/globalErrorHandler';
import { AuthModule } from './auth/auth.module';
import { AuthRoutingModule } from './auth/auth-routing.module';
import { UserModule } from './user/user.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReactiveFormsModule } from '@angular/forms';
import { HomePageComponent } from './components/home-page/home-page.component';
import { AgGridModule } from 'ag-grid-angular';
import 'ag-grid-enterprise';
import { AuditorvisibilityRemarkComponent } from './components/auditorbench/auditsummary/auditorvisibility-remark/auditorvisibility-remark.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { UrlConfigService } from './service/url-config.service';

//import { VisibilityStatusComponent } from './components/workspace/visibility-status/visibility-status.component';
//import { RemarkvisibilitystatusComponent } from './components/workspace/remarkvisibilitystatus/remarkvisibilitystatus.component';

export function StartupServiceFactory(startupService: StartupService) {
  return () => startupService.load();
}
//TO CHANGE THE LANGUAGE - INTERNATIONALIZATION
export function StartupLanguageServiceFactory(startupService: StartupService) {
  return () => startupService.use('en');
}
//TO GET THE API SERVER URL
export function UrlConfigServiceFactory(urlConfigService: UrlConfigService) {
  return () => urlConfigService.loadAppConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    SampleComponent,
    EditmodalComponent,
    SsoLoginComponent,
    Error404PageComponent,
    HomePageComponent,
  ],
  imports: [
    NgxMatDatetimePickerModule,
    NgxMatSelectSearchModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxMatMomentModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule,
    SharedModule,
    ThemeModule,
    FormlyModule.forRoot(),
    ToastrModule.forRoot(),
    QuillModule.forRoot(),
    StorageServiceModule,
    PdfViewerModule,
    EditorModule,
    AppRoutingModule,
    AuthModule,
    UserModule,
    AgGridModule.withComponents([]),MatTabsModule
  ],
  entryComponents: [EditmodalComponent],
  providers: [
    StartupService,
    SidebarComponent,
    DatePipe,
    { provide: LocationStrategy, useClass: HashLocationStrategy },

    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: StartupServiceFactory,
    //   deps: [StartupService],
    //   multi: true,
    // },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [UrlConfigService],
      useFactory: UrlConfigServiceFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptor,
      multi: true,
    },

    StartupService,
    {
      provide: APP_INITIALIZER,
      useFactory: StartupLanguageServiceFactory,
      deps: [StartupService],
      multi: true,
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
